import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import NumericInput from "src/main/PointOfSale/CurrentSalePanel/NumericInput"

import Form from "src/components/Form"

const toFeet = (inches) => Math.floor((inches || 0) / 12)
const toRemainderInches = (inches) => (inches || 0) % 12

const DimensionInput = ({ id, label, value, onChange, error, required }) => {
  const [feet, setFeet] = useState(toFeet(value))
  const [inches, setInches] = useState(toRemainderInches(value))

  // Keep local state in sync if the parent updates `value` externally (e.g. RHF reset).
  useEffect(() => {
    setFeet(toFeet(value))
    setInches(toRemainderInches(value))
  }, [value])

  const emitTotal = (nextFeet, nextInches) => {
    const safeFeet = Number.isFinite(nextFeet) ? nextFeet : 0
    const safeInches = Number.isFinite(nextInches) ? nextInches : 0
    onChange(safeFeet * 12 + safeInches)
  }

  return (
    <div>
      <Form.Label htmlFor={`${id}-feet`} required={required}>
        {label}
      </Form.Label>
      <div className="flex gap-2">
        <NumericInput
          id={`${id}-feet`}
          ariaLabel={`${label} in feet`}
          value={feet}
          onChange={(v) => {
            setFeet(v)
            emitTotal(v, inches)
          }}
          icon="ft"
          iconPosition="right"
          precision={0}
          valueMultiplier={1}
          inputMode="numeric"
          hasErrors={!!error}
        />
        <NumericInput
          id={`${id}-inches`}
          ariaLabel={`${label} in inches`}
          value={inches}
          onChange={(v) => {
            setInches(v)
            emitTotal(feet, v)
          }}
          icon="in"
          iconPosition="right"
          precision={0}
          valueMultiplier={1}
          inputMode="numeric"
          maxValue={11}
          hasErrors={!!error}
        />
      </div>
      {error && <Form.Error>{error}</Form.Error>}
    </div>
  )
}

DimensionInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  required: PropTypes.bool,
}

export default DimensionInput
